import { useIntl } from 'react-intl';

export default function Copyright() {
  const { formatMessage } = useIntl();

  return formatMessage({ id: 'footer.copyright' }, { year: new Date().getFullYear() });
}
